module.exports = __webpack_public_path__ + "img/icon_ai_cover@2x.abddf54f.png";